import Header from "../../../components/shared/Header";
import "../../../styles/shared/legal/PrivacyPolicy.scss";
import Image from "../../../images/image 96.png";
import { useEffect, useState } from "react";
import Footer from "../../../components/shared/Footer";
export default function PrivacyPolicy() {
  const [open, setOpen] = useState(false);
  const [numbers, setNumbers] = useState([]);
  const handleFaqOpen = (number) => {
    if (!numbers.includes(number)) {
      let temp = numbers;
      temp.push(number);
      setNumbers([...temp]);
    } else {
      let temp = numbers;
      temp.splice(temp.indexOf(number), 1);
      setNumbers([...temp]);
    }
  };
  const [openIndex, setOpenIndex] = useState(null);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(() => {
    // console.log('new number', numbers);
  }, [numbers]);


  
const dataItems = [
  {
    title: "1.1 Providing and Improving the Services",
    content:
      "To make the Services available, to manage user requests and interactions with the Services (e.g., login and authentication, modifying settings, etc.), to facilitate hosting and back-end infrastructure for our platform, to analyze and monitor usage, and to monitor and address service performance, security, and technical issues.",
  },
  {
    title: "1.2 Data Security and Monitoring",
    content:
      "We monitor usage patterns and implement security measures to protect your data while maintaining service performance and integrity.",
  },
  {
    title: "1.3 Service Optimization",
    content:
      "To respond to support requests and otherwise provide support for and resolve problems with the Services..",
  },
  {
      title: "1.4 Communications",
    content:
      "To send service, technical, and administrative emails, messages, and other communications. Service-related communications about changes to the Services and important Services-related notices, such as maintenance and security announcements, are essential to delivery of the Services and you cannot opt-out of these communications. Marketing communications, if any, about new product features, offerings, and other news about Closecarbon are optional; you have the choice whether or not to receive them and you may opt out by using the unsubscribe mechanism in such communications, or by changing the email preferences in your account.",

  },
  {
      title: "1.5 Account Management",
    content:
      "To contact you in connection with account management, feedback, and other administrative matters related to your account with us and the Services."
  },
  {
      title: "1.6 Security Purposes",
    content:
      "To help prevent and investigate security issues and abuse."
  },

  {
      title: "1.7 Legal Obligations",
    content:
      "To comply with legal obligations as required by applicable law, legal process, or regulations as described above."
  },

];


const dataItems2 = [
  {
    title: "2.1 With Your Consent",
    content:
      "Closecarbon may disclose your data, including Personal Information, to third parties when we have your express consent to do so. This includes any information that you post to your user page or otherwise on our Site and/or via the Services – by publishing such information via the Site or Services, you consent to Pachama’s disclosure of this information.",
  },
  {
    title: "2.2 Rendering the Services",
    content:
      "Closecarbon’s employees and contractors may have access to your data on a need to know and confidential basis to the extent necessary to render the Services and related support for the Services. We require such employees and contractors to treat your information consistent with this Privacy Policy",
  },
  {
    title: "2.3 Affiliates",
    content:
      "We may share your information with our affiliates, in which case we will require those affiliates to honour this Privacy Policy. Affiliates include our parent company and/or any subsidiaries (if any), companies with an ownership interest in Closecarbon, joint venture partners, or other companies that we control or that are under common control with us. ",
  },
  {
      title: "2.4 Third Party Providers",
    content:
      "Closecarbon engages third parties to process data in support of delivering of the Services (“Third Party Providers”). We may share your data, including Personal Information, with Third Party Service Providers (e.g., email services, platform hosting, cloud computing services, data storage and processing facilities) to the limited extent necessary to let them perform business functions and services for us or on our behalf in connection with the provision of the Services. ",

  },
  {
      title: "2.5 Third Party Services ",
    content:
      "You may enable or permit integrations with or use of Third-Party Services in connection with the Services. When enabled, Closecarbon may share certain data with such Third-Party Services as requested to effectuate the integration, including data regarding your credentials related to the Services. As mentioned above, Third Party Services are not owned or controlled by Closecarbon and third parties that have been granted access to your data may have their own policies and practices for its collection and use; you should check the privacy settings and notices of these Third-Party Services to understand their privacy practices. "
  },
  {
      title: "2.6 Enforcement of Agreements ",
    content:
      "Closecarbon may disclose data to ensure compliance with and to enforce contractual or legal obligations with respect to the Services and our business, including any applicable lease agreements."
  },

  {
      title: "2.7 Protection of Rights ",
    content:
      "Closecarbon may disclose data to protect and defend our rights and property, including intellectual property rights, and to ensure compliance with applicable laws and enforce third party rights, including intellectual property and privacy rights. "
  },
  
  {
      title: "2.8 Safety and Security ",
    content:
      "Closecarbon may disclose data to protect your safety and security; to protect the safety, security, and property of our users; and to protect the safety, security, and property of Closecarbon and our employees, agents, representatives, and contractors.  "
  },

];
  return (
    <div className="privacy">
      <Header />
      <div className="hero">
        <div className="ml-16">
          <div className="title text-[#141414]">Privacy policy</div>
          <div className="subtitle">
            At CloseCarbon, Your Trust is our commitment and we respect your
            privacy.
          </div>
        </div>
        <div>
          <img src={Image} alt="" />
        </div>
      </div>
      {/* body */}
      <div className="content">
        <div className="contentParagraph subtitleBold text-[#3B3B3B]">
          This Privacy Policy describes how we collect, use, and protect your data in connection with your use of the Services. By visiting our Site, by using the Services, you accept our practices described in this Privacy Policy, and you consent to our collection, use and disclosure of your information, including personally identifiable information, as described in this Privacy Policy. 

        </div>
        <div className="contentTitle text-[#141414]">Contact Us</div>
        <div className="contentParagraph text-[#3B3B3B]">
          Do not hesitate to contact us with any questions about your account or how to request for how to contact customer service for assistance. You may contact us at: support@closecarbon.com.  To contact our Data protection officer: info@closecarbon.com. Note that if you contact us to assist you, for your safety and ours we may need to authenticate your identity before fulfilling your request. 
        </div>
        <div className="contentTitle text-[#141414] ">How we use your information</div>
        <p className="font-medium text-[18px] mb-5">When you use our website</p>
        <div className="contentParagraph text-[#3B3B3B]">In connection with your use of the Services, we may receive various types of information related to you, as well as information you provide us about others. Sometimes you provide us with this data and sometimes data about you is collected automatically. You acknowledge and agree we may collect, process, store, access, and disclose Personal Information disclosed by you to facilitate the provision of Services and related support for the Services in the manner described in this Privacy Policy.
        <p className="font-medium text-[18px] mt-5 mb-5 text-[#141414] ">When you reach out to us online</p>
        <div className="mb-2 text-[#3B3B3B]">

        When you create or update an account for the Services with us, you provide us with data, including personal information, about yourself and any other information that you share or provide us. We also may collect personal information that you post, upload, store, display, transmit, or submit through the Services in any other manner. Although we will treat such information consistent with this Privacy Policy, we are not responsible for the content of any information, including Personal Information, that you provide to us, and by using the Services, you assume full responsibility for obtaining, and you represent that you have obtained, all necessary consents and permissions to provide such information to us.
        </div>
        
        <br />
        <div className="mb-2  text-[#3B3B3B]" >
        Closecarbon may also collect other information from you related to your use of the Services and your interactions with our Services (while this information may not typically contain Personal Information, we are not responsible for the content of such information). This information includes any such information that you affirmatively provide to Closecarbon, and may include: 

        </div>

<br/>
Closecarbon receives data when submitted to or through our Services, or if you contact us (whether by email, telephone, written correspondence, web-based forms, or otherwise), request support, interact with our social media accounts, or otherwise communicate with Closecarbon
        
        </div>
         <div className="flex flex-col gap-6 w-full  mx-auto">
      <h2 className="text-[18px] font-medium text-[#141414]">
        How we use your Data
      </h2>

      {dataItems.map((item, index) => (
        <div key={index} className="flex flex-col gap-3 border-b border-[#B1B1B1] pb-1 ">
          {/* Header */}
          <div className="flex justify-between items-center cursor-pointer py-4 " onClick={() => toggleItem(index)}>
            <h3 className="text-[16px] font-medium text-[#3B3B3B] ">{item.title}</h3>
            <span className="text-[#3B3B3B] text-3xl font-bold">
              {openIndex === index ? "−" : "+"}
            </span>
          </div>

          {/* Collapsible Content */}
          {openIndex === index && (
            <p className="text-[14px] text-[#3B3B3B] leading-[21px]">
              {item.content}
            </p>
          )}
        </div>
      ))}
    </div>


{/* second content */}

<div className="contentTitle text-[#141414] mt-5">
  Sharing and disclosure of data:
</div>
<div className="text-[16px] mb-10 text-[#3B3B3B]">
  Closecarbon will not use or disclose your Personal Information for any purpose other than to the extent reasonably necessary to perform the Services and related support for the Services. As a matter of policy, absent your express consent, we do not sell or rent information about you, and we will not disclose information about you in a manner inconsistent with this Privacy Policy except as required by law or government regulation.  We cooperate with law enforcement inquiries, to enforce laws such as those regarding intellectual property rights, fraud, and other personal rights. WE CAN (AND YOU AUTHORIZE US TO) DISCLOSE ANY INFORMATION ABOUT YOU TO LAW ENFORCEMENT, OTHER GOVERNMENT OFFICIALS OR ANY OTHER THIRD PARTY THAT WE, AT OUR SOLE DISCRETION, BELIEVE NECESSARY OR APPROPRIATE IN CONNECTION WITH AN INVESTIGATION OF FRAUD, INTELLECTUAL PROPERTY INFRINGEMENT OR OTHER ACTIVITY THAT IS ILLEGAL OR MAY EXPOSE US, OR YOU, TO LIABILITY. 
</div>


      {dataItems2.map((item, index) => (
        <div key={index} className="flex flex-col gap-3 border-b border-[#B1B1B1] pb-1">
          {/* Header */}
          <div className="flex justify-between items-center cursor-pointer py-7" onClick={() => toggleItem(index)}>
            <h3 className="text-[16px] font-medium text-[#3B3B3B]">{item.title}</h3>
            <span className="text-[#3B3B3B] text-3xl font-bold">
              {openIndex === index ? "−" : "+"}
            </span>
          </div>

          {/* Collapsible Content */}
          {openIndex === index && (
            <p className="text-[14px] text-[#3B3B3B] leading-[21px]">
              {item.content}
            </p>
          )}
        </div>

      
      ))}



<div className="contentTitle text-[#141414] mt-5">
  Security Measures 
</div>

<div className="text-[16px] mb-10 text-[#3B3B3B]">
  Closecarbon maintains physical, technical, and administrative procedures to protect the data we collect and to secure it from improper of unauthorized use. We work hard to protect data in our custody and control from loss, misuse, and unauthorized access, use, disclosure, modification, or destruction, and to use industry-standard security measures in order to ensure an appropriate level of security in light of reasonably available methods in relation to the risks and nature of the information we collect. 
</div>


<div className="contentTitle text-[#141414] mt-5">
  International Data Transfers 
</div>

<div className="text-[16px] mb-10 text-[#3B3B3B]">
Closecarbon primarily processes and stores data in connection with the Services in Nigeria. However, it is possible that data may be processed other countries by Third-Party. We will take measures to ensure that your Personal Information remains protected to the standards described in this Privacy Policy and any such transfers comply with applicable data protection laws. In certain circumstances, courts, law enforcement agencies, regulatory agencies or security authorities in those other countries may be entitled to access your Personal Information
</div>



<div className="contentTitle text-[#141414] mt-5">
  Enforcement
</div>

<div className="text-[16px] mb-10 text-[#3B3B3B]">
Closecarbon will actively monitor its relevant privacy and security practices to verify adherence to this Privacy Policy. Any agents, contractors, service providers, or other third parties subject to this Privacy Policy that Closecarbon determines to be in violation of this Privacy Policy or applicable data protection laws will be subject to disciplinary action up to and including termination of applicable services. Kindly contact us immediately at the contact information provided under the “Contact Us” heading above if you believe there has been a material violation of this Privacy Policy. 
</div>




<div className="contentTitle text-[#141414] mt-5">
  Changes to Privacy Policy
</div>

<div className="text-[16px] mb-10 text-[#3B3B3B]">
We reserve the right make changes to this Privacy Policy from time to time, in whole or in part, in our sole discretion, at any time without prior notice by posting an updated version of this Privacy Policy on the Site or when you access the Services. When we do, we will revise the “last updated” date at the beginning of the Privacy Policy. We will make commercially reasonable efforts to notify you by email, through the Services (at log-in or otherwise), and/or by posting a prominent notice on our Site that our Privacy Policy has been updated. Any changes, modifications, or updates to this Privacy Policy will become effective immediately upon posting. By continuing to use the Services, you agree to be bound changes we make to this Privacy Policy. If you disagree with the changes to this Privacy Policy, your only remedy is to discontinue use of the Services and deactivate your account. 
</div>



      </div>


      <Footer />
    </div>
  );
}
